import * as R from "ramda";

const mixin = {
  data() {
    return { eventStatus: {} };
  },
  methods: {
    hasEventState(key) {
      return Boolean(this.eventStatus[key]);
    },
    addEventState(key) {
      const eventStatus = R.clone(this.eventStatus);
      eventStatus[key] = true;
      this.eventStatus = eventStatus;
    },
    removeEventState(key) {
      const eventStatus = R.clone(this.eventStatus);
      delete eventStatus[key];
      this.eventStatus = eventStatus;
    },
  },
};

export default mixin;
